import React from 'react';
import WarningIcon from '@svg/warning.svg?react';
import InfoIcon from '@svg/info.svg?react';
import { Tooltip } from 'antd';
import { ConnectionModel } from '../../connection.model';

interface ValidationErrorProps {
    message: string;
    onDeselectConnection?: () => void;
    deselectText?: string;
    deselectedConnections?: ConnectionModel[];
}

const ValidationError: React.FC<ValidationErrorProps> = ({
      message,
      onDeselectConnection,
      deselectText,
      deselectedConnections,
}) => {

    const deselectedNames = deselectedConnections?.map(conn =>
        conn.connectionName || conn.circuitId
    )?.join(', ');

    return (
        <div className="validation-error">
            <div className="validation-error-icon"><WarningIcon /></div>
            <div className="validation-error-message">{message}
            {onDeselectConnection && deselectedConnections && (
                <button type="button" className="validation-error-action" onClick={onDeselectConnection}>
                    {deselectText ?? 'Deselect ineligible connection'}{deselectedConnections.length > 1 ? 's' : ''}
                    <Tooltip title={deselectedNames}>
                        <span className="validation-error-info-icon"><InfoIcon /></span>
                    </Tooltip>
                </button>
            )}
            </div>
        </div>
    );
};

export default ValidationError;
